<template>
    <div class="load-more">
        <hr />
        <div class="load-more-btn">
            <slot v-if="!active">{{ text }}</slot>
            <div v-else><img src="@/assets/styles/frontend-library/images/spinner-animated.svg" alt="Loading more..."/></div>
        </div>
        <hr />
    </div>
</template>

<script>

export default {
  name: 'LoadMore',
  props: {
    active: {
      required: true,
      default: false,
      type: Boolean,
    },
    text: { default: 'Load more' },
  },
  data() {
    return {

    };
  },
};
</script>

<style lang="scss" scoped>
    .load-more {
        @apply ut-relative ut-text-center ut-h-5 ut-flex ut-my-8;
        justify-content: space-between;

        hr {
            @apply ut-border-t ut-border-solid ut-w-full;
            border-color: #D5D4D3;
        }

        .load-more-btn {
            @apply ut-mx-auto ut--mt-3 ut-cursor-pointer;
            min-width: 175px;
            color: rgba(#001B19, 0.4);


            img {
                width: 45px;
                margin-top: -13px;
            }
        }

    }

</style>
